import { Component, Input } from '@angular/core';

@Component({
    selector: 'dbm-progress-bar',
    template: require('./dbm-progress-bar.component.html'),
    styles: [require('./dbm-progress-bar.component.scss')]
})
export class DbmProgressBarComponent{

    @Input() public progress: number = 0;

    constructor() {
    }

    public calculatedProgress(): number {
        if (this.progress) {
            return this.progress > 100 ? 100 : this.progress;
        }
        return 0;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/dbm-progress-bar/dbm-progress-bar.component.ts